import { useEffect } from 'react'
import { useNotificationService } from '@hapana/shared/web/services/notification.service'

export const useServiceWorkerMessages = () => {
  const { showNotification } = useNotificationService()

  useEffect(() => {
    const channel = new BroadcastChannel('fcm-notifications')

    const messageHandler = (event) => {
      if (event.data?.type !== 'FCM_NOTIFICATION') return
      const fcmData = event.data.data?.data
      if (fcmData?.type === 'EQUIPMENT_STATUS_UPDATED') return
      showNotification(event.data.data)
    }

    channel.addEventListener('message', messageHandler)

    return () => {
      channel.removeEventListener('message', messageHandler)
      channel.close()
    }
  }, [])
}
